import React, { useState } from 'react';
//@ts-ignore
import * as styles from './DiscountBanner.module.css';
import CtaLink from '../Global/CtaLink';
import { graphql } from 'gatsby';
import RichText from '../Global/RichText';
import loadable from '@loadable/component';

const Jotform = loadable(() => import('../Jotform'));
import {
    getMediaData,
    getColor,
    getMultiChoice,
    optimizeKontentImageUrl,
    imagePreset,
    getDisplayDimensions,
    buildKontentSrcSet,
} from '../Global/DataUtils/index';

import {
    KontentStringValue,
    KontentMedia,
    BrandColor,
    KontentRichText,
} from '../../../types/KontentProps';

interface Props {
    kontentItemId?: string;
    discountLargeImage?: {
        altText: string;
        file: {
            file: {
                url: string;
            };
        };
    };
    discountSmallImage?: {
        altText: string;
        file: {
            file: {
                url: string;
            };
        };
    };
    content_panel__content_panel_color: BrandColor;
    content_panel__content_panel_font_color: BrandColor;
    discounts: {
        value: {
            elements: discountElements;
        }[];
    };
    general_large___small_image_selection__large: KontentMedia;
    general_large___small_image_selection__small: KontentMedia;
    default_message: KontentRichText;
}

interface discountElements {
    activation_date: {
        value: KontentStringValue;
    };
    expiration_date: {
        value: KontentStringValue;
    };

    discount_start: {
        value: KontentStringValue;
    };
    discount_end: {
        value: KontentStringValue;
    };
    cta_configuration__cta_window_action: {
        value: [
            {
                name: string;
                codename: string;
            }
        ];
    };
    cta_configuration__cta_location_anchor_point: {
        value: string;
    };

    cta_configuration__cta_label: {
        value: KontentStringValue;
    };
    copy: KontentRichText;
    cta_type: {
        value: [
            {
                name: string;
                codename: string;
            }
        ];
    };

    headline: {
        value: KontentStringValue;
    };

    form_selection: {
        value: string;
    };
    display_type: {
        value: [
            {
                name: string;
                codename: string;
            }
        ];
    };
}

interface countDown {
    days?: number;
    hours?: number;
    minutes?: number;
    seconds?: number;
    difference: number;
}

const discountBanner: React.FC<Props> = ({
    kontentItemId,
    content_panel__content_panel_font_color,
    content_panel__content_panel_color,
    general_large___small_image_selection__large,
    general_large___small_image_selection__small,
    discounts,
    default_message,
}) => {
    const {
        activation_date,
        expiration_date,
        discount_start,
        discount_end,
        cta_configuration__cta_label,
        cta_configuration__cta_location_anchor_point,
        copy,
        headline,
        form_selection,
        display_type,
        cta_type,
        cta_configuration__cta_window_action,
    } = discounts.value[0]?.elements;

    const [showJotform, setShowJotform] = React.useState(false);
    const [jotFormOpen, setJotFormOpen] = useState(false);
    const countType = getMultiChoice(display_type) || 'count_down';
    const [timeLeft, setTimeLeft] = useState<countDown>({ difference: 0 });

    const calculateTimeLeft = () => {
        let targetDate =
            countType == 'count_down'
                ? new Date(discount_end.value.toString())
                : new Date(discount_start.value.toString());

        let now = new Date();

        const difference = targetDate.getTime() - now.getTime();
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        if (difference >= 0) {
            setTimeLeft({
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds,
                difference,
            });
        } else {
            setTimeLeft({ difference: 0 });
        }
    };

    const [displayDiscountBanner, setdisplayDiscountBanner] = useState(false);
    const countDownHeader = ['days', 'hours', 'minutes', 'seconds'];

    const headlineValue =
        countType == 'count down' ? 'promotion ends in' : 'promotion begins in';
    const discountBgImageLargeData = getMediaData(
        general_large___small_image_selection__large
    );
    const discountBgImageLarge = discountBgImageLargeData?.url;

    const backgroundColor = getColor(
        content_panel__content_panel_color
    )?.toLowerCase();

    const textColor = getColor(content_panel__content_panel_font_color);
    const discountBgImageLargeAltText =
        discountBgImageLargeData?.description ||
        discountBgImageLargeData?.name ||
        'sunlightenImage';
    const discountBgImageSmallData = getMediaData(
        general_large___small_image_selection__small
    );
    const discountBgImageSmall = discountBgImageSmallData?.url;
    const anchorTarget =
        cta_configuration__cta_window_action?.value[0]?.name.toLowerCase() ==
        'new window'
            ? '_blank'
            : '_self';

    const checkDiscountBanner = () => {
        const displayBanner = timeLeft.difference > 0;

        setdisplayDiscountBanner(displayBanner);
    };

    React.useEffect(() => {
        //validating if to show discountbanner or not by given activation/expiration date
        checkDiscountBanner();
        setTimeout(() => {
            calculateTimeLeft();
        }, 1000);
    }, [timeLeft]);

    const BackgroundColor = backgroundColor ? backgroundColor : '';
    const TextColor = textColor ? textColor : '';

    const renderCta = () => {
        return (
            <div className={styles.buttons}>
                {cta_type?.value[0]?.name == 'Page' ||
                cta_type?.value[0]?.name == 'page' ? (
                    cta_configuration__cta_location_anchor_point?.value && (
                        <div className={styles.customCTAButton}>
                            <CtaLink
                                href={
                                    cta_configuration__cta_location_anchor_point.value
                                }
                                target={anchorTarget}
                                color={TextColor}
                                hoverBorderColor={TextColor}
                                hoverFontColor={TextColor}
                                hoverBgColor={BackgroundColor}
                            >
                                {cta_configuration__cta_label.value}
                            </CtaLink>
                        </div>
                    )
                ) : (
                    <>
                        <div className={styles.customCTAButton}>
                            <button
                                onClick={() => setShowJotform(true)}
                                type="button"
                                style={{
                                    color: TextColor,
                                    border: `2px solid ${TextColor} `,
                                    backgroundColor: backgroundColor,
                                }}
                                data-kontent-element-codename="cta_configuration__cta_label"
                            >
                                {cta_configuration__cta_label.value}
                            </button>
                        </div>
                        <Jotform
                            formStyle={'popup'}
                            formUrl={form_selection.value}
                            display={showJotform}
                            onPopUpClose={() => {
                                setShowJotform(false);
                            }}
                        />
                    </>
                )}
            </div>
        );
    };

    return (
        <div
            className={styles.componentWrapper}
            data-kontent-item-id={kontentItemId}
        >
            <div>
                {discountBgImageLarge || discountBgImageSmall ? (
                    <picture
                        className={styles.picture}
                        data-kontent-element-codename="general_large___small_image_selection__large"
                    >
                        {discountBgImageSmall && (
                            <source
                                srcSet={buildKontentSrcSet(
                                    discountBgImageSmall,
                                    imagePreset.halfWidth.mobile.w,
                                    {
                                        fm: 'webp' as const,
                                        q: imagePreset.halfWidth.mobile.q,
                                    }
                                )}
                                sizes="100vw"
                                media="(max-width: 480px)"
                                {...getDisplayDimensions(
                                    discountBgImageSmallData?.width,
                                    discountBgImageSmallData?.height,
                                    imagePreset.halfWidth.mobile.w
                                )}
                            />
                        )}
                        {discountBgImageLarge && (
                            <img
                                src={optimizeKontentImageUrl(
                                    discountBgImageLarge,
                                    imagePreset.fullWidth.desktop
                                )}
                                srcSet={buildKontentSrcSet(
                                    discountBgImageLarge,
                                    imagePreset.fullWidth.desktop.w,
                                    {
                                        fm: 'webp' as const,
                                        q: imagePreset.fullWidth.desktop.q,
                                    }
                                )}
                                sizes="100vw"
                                alt={discountBgImageLargeAltText}
                                {...getDisplayDimensions(
                                    discountBgImageLargeData?.width,
                                    discountBgImageLargeData?.height,
                                    imagePreset.fullWidth.desktop.w
                                )}
                                loading="lazy"
                            />
                        )}
                    </picture>
                ) : null}
            </div>

            <div
                style={{ backgroundColor: backgroundColor, color: TextColor }}
                className={styles.contentWrappers}
            >
                {displayDiscountBanner ? (
                    <div
                        style={{ display: 'flex' }}
                        className={styles.contentWrapper}
                    >
                        <div className={styles.timerBanner}>
                            <div
                                className={styles.promotionBanner}
                                data-kontent-element-codename="headline"
                            >
                                {headline?.value
                                    ? headline.value
                                    : headlineValue}
                            </div>

                            <div className={styles.countdownTimeContainer}>
                                {Object.keys(timeLeft).length > 1
                                    ? Object.keys(timeLeft).map(
                                          (key: string, index: number) => {
                                              if (
                                                  key != 'difference' &&
                                                  (key == 'days' ||
                                                      key == 'hours' ||
                                                      key == 'minutes' ||
                                                      key == 'seconds')
                                              ) {
                                                  return (
                                                      <div
                                                          className={
                                                              styles.countdown
                                                          }
                                                          key={index}
                                                      >
                                                          <span
                                                              className={
                                                                  styles.countDownNumber
                                                              }
                                                          >
                                                              {timeLeft[key]}
                                                          </span>
                                                          <span
                                                              className={
                                                                  styles.countDownText
                                                              }
                                                          >
                                                              {key.toUpperCase()}
                                                          </span>
                                                      </div>
                                                  );
                                              }
                                          }
                                      )
                                    : countDownHeader.map(
                                          (key: String, index: number) => {
                                              return (
                                                  <div
                                                      className={
                                                          styles.countdown
                                                      }
                                                      key={index}
                                                  >
                                                      <span
                                                          className={
                                                              styles.countDownNumber
                                                          }
                                                      >
                                                          00
                                                      </span>
                                                      <span
                                                          className={
                                                              styles.countDownText
                                                          }
                                                      >
                                                          {key.toUpperCase()}
                                                      </span>
                                                  </div>
                                              );
                                          }
                                      )}
                            </div>
                        </div>
                        <div
                            style={{ marginLeft: '1px' }}
                            className={styles.container}
                        >
                            <div className={styles.defaultmessage}>
                                {RichText(
                                    copy,
                                    false,
                                    undefined,
                                    undefined,
                                    'copy'
                                )}
                            </div>
                            {renderCta()}
                        </div>
                    </div>
                ) : (
                    <div className={styles.container}>
                        <div className={styles.defaultmessage}>
                            {RichText(
                                default_message,
                                false,
                                undefined,
                                undefined,
                                'default_message'
                            )}
                        </div>
                        {renderCta()}
                    </div>
                )}
            </div>
        </div>
    );
};

export default discountBanner;

export const query = graphql`
    fragment DiscountBanner on kontent_item_component___discount_banner {
        elements {
            discounts {
                value {
                    ... on kontent_item_content_item___discount {
                        id
                        elements {
                            headline {
                                value
                            }
                            form_selection {
                                value
                            }
                            expiration_date {
                                value(
                                    formatString: ""
                                    fromNow: false
                                    locale: ""
                                    difference: ""
                                )
                            }
                            display_type {
                                value {
                                    name
                                    codename
                                }
                            }
                            discount_start {
                                value(
                                    formatString: ""
                                    difference: ""
                                    locale: ""
                                    fromNow: false
                                )
                            }
                            discount_end {
                                value(
                                    difference: ""
                                    formatString: ""
                                    fromNow: false
                                    locale: ""
                                )
                            }
                            cta_type {
                                value {
                                    name
                                    codename
                                }
                            }
                            cta_configuration__cta_window_action {
                                value {
                                    name
                                    codename
                                }
                            }
                            cta_configuration__cta_location_anchor_point {
                                value
                            }
                            cta_configuration__cta_location {
                                value {
                                    ... on kontent_item_content_item___third_party_link {
                                        id
                                        elements {
                                            third_party_url {
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                            cta_configuration__cta_label {
                                value
                            }
                            copy {
                                value
                            }
                            activation_date {
                                value(difference: "", formatString: "")
                            }
                        }
                    }
                }
            }
            default_message {
                value
            }
            content_panel__content_panel_font_color {
                value {
                    ... on kontent_item_list___brand_colors {
                        id
                        elements {
                            color_hex_value {
                                value
                            }
                        }
                    }
                }
            }
            content_panel__content_panel_color {
                value {
                    ... on kontent_item_list___brand_colors {
                        id
                        elements {
                            color_hex_value {
                                value
                            }
                        }
                    }
                }
            }
            general_large___small_image_selection__large {
                value {
                    ... on kontent_item_media___image {
                        id
                        elements {
                            file {
                                value {
                                    url
                                }
                            }
                        }
                    }
                }
            }
            general_large___small_image_selection__small {
                value {
                    ... on kontent_item_media___image {
                        id
                        elements {
                            file {
                                value {
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
